module.exports = __webpack_public_path__ + "img/payment09.c81cea4b.png";